import { render, staticRenderFns } from "./tourismInfo.vue?vue&type=template&id=bf0e6cc2&scoped=true&"
import script from "./tourismInfo.vue?vue&type=script&lang=js&"
export * from "./tourismInfo.vue?vue&type=script&lang=js&"
import style0 from "./tourismInfo.vue?vue&type=style&index=0&id=bf0e6cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0e6cc2",
  null
  
)

export default component.exports